const providerAliases: Record<string, string> = {
  'google-mail': 'gmail',
  gmail: 'gmail',
  'google-sheet': 'google-sheets',
  'google-sheets': 'google-sheets',
  'cal-com-v2': 'cal',
  cal: 'cal',
  zoho: 'zoho-crm',
  zohocrm: 'zoho-crm',
  'zoho-crm': 'zoho-crm',
  zohodesk: 'zoho-desk',
  'zoho-desk': 'zoho-desk',
  zohopeople: 'zoho-people',
  'zoho-people': 'zoho-people',
}

/**
 * Canonical provider key across the two naming schemes still on disk: actions saved
 * before the integrations-service cutover carry the old provider key ("google-mail"),
 * while connections and the catalog derive a slug from the app name (GMAIL → "gmail").
 * Matching a saved action to a connection must compare through this, never raw equality.
 */
export const providerKey = (provider: string) => {
  const normalizedProvider = provider.toLowerCase().replaceAll('_', '-')
  return providerAliases[normalizedProvider] ?? normalizedProvider
}
